import { Location } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { finalize, first, map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { TreeModel } from 'src/app/core/models/tree-model';
import Utils from 'src/app/core/services/app-utils';
import { AsEnterpriseService } from 'src/app/core/services/as-enterprise.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { HandsontableService } from 'src/app/core/services/handsontable.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningSmsContractService } from 'src/app/core/services/warning-sms-contract.service';
import { AlertConfigDataHDLDComponent } from 'src/app/shared/components/alert-config-data-hdld/alert-config-data-hdld.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { WaringSignatureComponent } from 'src/app/shared/components/waring-signature/waring-signature.component';
import { WarningNotChangeContractCodeComponent } from 'src/app/shared/components/warning-not-change-contract-code/warning-not-change-contract-code.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { DocumentDTO } from 'src/app/shared/models/document-dto.model';
import { SignPosition } from '../../../../../../shared/models/sign-position.model';
import { SelectDocumentTypeComponent } from '../select-document-type/select-document-type.component';
import { DocumentFormMohaComponent } from './document-form-moha/document-form-moha.component';
import { FillGeneralContractInfoMohaComponent } from './fill-general-contract-info-moha/fill-general-contract-info-moha.component';
import { GeneralFormInfoMohaComponent } from './general-form-info-moha/general-form-info-moha.component';
import { SignatureMohaDialogComponent } from './signature-dialog-moha/signature-moha-dialog.component';
import { WarningDataAuthenticationComponent} from 'src/app/shared/components/warning-data-authentication/warning-data-authentication.component';
import { SignAuthenticationPopupComponent } from '../../document/add-document-moha/sign-aunthentication-popup/sign-aunthentication-popup.component';
import { EnterIdentityVneidComponent } from 'src/app/shared/components/enter-identity-vneid/enter-identity-vneid.component';
import { RequestConfirmIdentityComponent } from 'src/app/shared/components/request-confirm-identity/request-confirm-identity.component';
import { DeviceDetectorService } from 'ngx-device-detector';


// define type of document.
const FormActionType = 0;
const FileUploadType = 1;
declare var $: any;

@Component({
  selector: 'app-add-document-moha',
  templateUrl: './add-document-moha.component.html',
  styleUrls: ['./add-document-moha.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddDocumentMohaComponent implements OnInit, AfterViewInit, OnDestroy {
  // Hiển thị trang tìm kiếm hay ko
  isShowListPage: boolean = true

  private pdfSrc: string;
  private fileUpload: File;
  public valueSelect: number;
  public contractId: string;
  public flagCopy = false;
  public termination: boolean = false;
  public terminationType: number;
  private show = true;
  private clearData = false;
  private showPopup = false;
  constructor(
    private documentMohaService: DocumentMohaService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toastr: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    public createContractMohaService: CreateContractMohaService,
    private documentTypeService: DocumentTypeService,
    private warningSmsContractService: WarningSmsContractService,
    private location: Location,
    public handsontableService: HandsontableService,
    private digitalCertificateService: DigitalCertificateService,
    private contractService: ContractService,
    private asEnterpriseService: AsEnterpriseService,
    public deviceService: DeviceDetectorService,
  ) {
    this.createContractMohaService.resetData();
    this.handsontableService.dirty.next(false);
    // localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
    this.language = localStorage.getItem('__language') || 'vi';
    pdfDefaultOptions.renderInteractiveForms = false;
    this.userType = localStorage.getItem('userType');
    // localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
    pdfDefaultOptions.renderInteractiveForms = false;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.contractId = params.id;
        this.isShowStep = true;
      }
    });
    this.route.queryParams.subscribe(queryParams => {
      if(queryParams.isFromExportReport){
        this.isShowListPage = false
      }
      if (queryParams.flagCopy && queryParams.flagCopy !== "false") {
        this.flagCopy = true;
        this.createContractMohaService.isCopy = true;
        this.isShowListPage = false
      }
      this.openSelected = queryParams.openSelected || 0;
      if(queryParams.termination){
        this.termination = queryParams.termination;
        this.terminationType = queryParams.terminationType
      }
    });
  }

  public isNegotiate = false;
  public isShowReferencePdf = false;
  public language: string;
  public SCREEN_SIZE = SCREEN_SIZE;
  userType: any;

  SIDEBAR_CURRENT_STATUS = 'SidebarCurrentStatus';
  COLLAPSED = 'Collapsed';
  documentTypeEnterpriseId: any;
  dataTree: Array<TreeModel> = [];

  @ViewChild(FillGeneralContractInfoMohaComponent, {
    read: FillGeneralContractInfoMohaComponent,
    static: true
  }) fillGeneralContractInfoMohaComponent;

  @ViewChild(GeneralFormInfoMohaComponent, {
    read: GeneralFormInfoMohaComponent,
    static: true
  }) generalFormInfoMohaComponent: GeneralFormInfoMohaComponent;
  @ViewChild('documentForm', {
    static: true
  })
  public documentFormMohaComponent: DocumentFormMohaComponent;

  // Button upload
  @ViewChild('btnUpload', { read: '', static: false }) btnUpload: ElementRef;
  // Input file
  @ViewChild('inputUpload', { read: '', static: false }) inputUploadFile: ElementRef;

  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  isShowStep = false;
  current = 0;
  currentUpdate :any;
  isDisableNextButton = false;
  openSelected: number;
  warningContractQuantity = false;
  eventWarningContractSubscription;
  subscriptions: Subscription = new Subscription();
  public choose_form: boolean;
  isSignature: boolean
  isSavingData: boolean = false;
  isSaveDraft: boolean = true;
  isOnAutoNumber: boolean = false;
  refreshContractCode: boolean = false;

  maxSize: number = 0
  maxSizeSystem: number = 0;
  maxPerMainFile: number = 0;
  maxPerAttachFile: number = 0;
  mesage: string = '';
  fileUploadSize: number = 0;
  biggerThan10MBFileSize: number;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  size10MB = 10*1024*1024;
  size150MB = 150*1024*1024;
  size1MB = 1*1024*1024;
  arrFile: any = [];
  isShowFileError: boolean = false;
  formFile: any;
  originalContract: any;
  oneTurn = true;
  dataCheckVneid = {
    typeVerify: '',
    certificateNoCCCD: '',
    timeWaitShare: 60
  }
  ngOnInit() {
    // deactive for reload route
    //merge 21511

    this.isUpdate = this.route.snapshot.queryParams && (this.route.snapshot.queryParams.typeUpdate || (this.route.snapshot.queryParams.goFrom == 'hdld' && !this.route.snapshot.queryParams.flagCopy  && !this.route.snapshot.queryParams.termination));
    if(this.isUpdate){
      this.isShowListPage = false
    }
    //merge 21511
    this.getDataCountNumberDocumentOfEnterpriseByService();
    const shouldReuseRouteSub = this.router.routeReuseStrategy.shouldReuseRoute = (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) => {
      if (this.clearData || this.contractId) {
        return false;
      }
      if (!this.isShowStep || !this.show || (!this.createContractMohaService.isDirty && !this.createContractMohaService.changeFileOutput)) {
        return false;
      }
      if (!this.showPopup) {
        this.showPopup = true;
        let message;
        if (this.current === 0) {
          message = this.message.getMessage('messages.cancel_create_contract_step1');
        } else {
          message = this.message.getMessage('messages.cancel_create_contract_step2');
        }
        const confirmDialog = this.dialog.open(WarningComponent, {
          width: '40%',
          data: message
        });
        confirmDialog.afterClosed().subscribe(res => {
          this.showPopup = false;
          if (res) {
            this.clearData = true;
            this.router.navigateByUrl(window.location.pathname);
          }
        });
      }
      return true;
    };
    this.subscriptions.add(shouldReuseRouteSub);
    if (this.router.url.includes('/home-enterprise/new-document-moha') || this.flagCopy) {
      /**
       * Có thể không dùng QuantitySms đã có khi lấy thông tin document
       * */
      this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
      this.eventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
        //merge 21511
        (response) => {
          if (response.isBuyContract10Mb && !response.isBuyContract1Mb) {
            if (response.contractQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else if (!response.isBuyContract10Mb && response.isBuyContract1Mb) {
            if (response.contract1MbQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else if (response.isBuyContract10Mb && response.isBuyContract1Mb) {
            if (response.contract1MbQuantity <= 0 && response.contractQuantity <= 0) {
              this.warningContractQuantity = true;
            }
          } else {
            this.warningContractQuantity = true;
          }
          if (this.warningContractQuantity === true) {
            //merge 21511
            // this.disableInput();
          } else {
            // Redirect from Dashboard: default open select file or template list for selection
            if (this.openSelected == 1) {
              this.inputUploadFile.nativeElement.click();
              this.openSelected = null;
            } else if (this.openSelected == 2) {
              document.getElementById('btnSelectTemplate').click();
              this.openSelected = null;
            }
          }
        }
      );

      this.subscriptions.add(this.eventWarningContractSubscription);
    }
    this.createContractMohaService.selectedTemplate.asObservable().subscribe(rs => {
      if (rs) {
        //this.getServiceTypeByDocumentTypeId(rs.id);
      }
    });
    this.subscribeData();
    if (this.contractId) {
      this.createContractMohaService.isUpdateDocument = true;
      this.documentMohaService.getDocumentById(this.contractId).subscribe(res => {
        if (!res || !res.data || !res.data.contractDTO) {
          return;
        }
        let contract
        if(this.termination){
          contract = DocumentDTO.build();
          contract.contractTerminationId = this.contractId;
          contract.formType = 'CONTRACT_TERMINATION';
          contract.mainContractAttachments = [];
          contract.contractAttachments = [];
          contract.enterpriseSign = [];
          contract.userSign = [];
          contract.contractSharePartners = [];
          contract.newUploadContractAttachments = [];
          contract.typeId = 1;
          contract.enterpriseId = localStorage.getItem('enterpriseId');
          contract.isConfirmBCT = !this.commonService.checkEnterpriseType();
          contract.name = "Thanh lý hợp đồng " + res.data.contractDTO.name;
          if(contract.name.length > 100){
            contract.name = contract.name.slice(0,100);
          }
          contract.code = ''
          const contractTerminations = [
            {
              id: this.contractId,
              code: res.data.contractDTO.code,
              name: res.data.contractDTO.name,
              status: 4,
              typeId: res.data.contractDTO.typeId
            }
          ]
          this.createContractMohaService.contractTerminations.next(contractTerminations)
        } else {
          contract = res.data.contractDTO;
          contract.customerMohaId = res.data.customerMohaId;
          if(res.data.contractTerminations && res.data.contractTerminations.length > 0){
            this.createContractMohaService.contractTerminations.next(res.data.contractTerminations)
          }
          if (contract.formType === 'CONTRACT_APPENDIX') {
            this.originalContract = res.data.contractOriginalDTO.id;
            contract.editProperty = res.data.editProperty;
            this.createContractMohaService.originalContract.next(this.originalContract);
            contract.dataOriginalContract = [];
            contract.dataOriginalContract.push(res.data.contractOriginalDTO);
            contract.contractMohaUpdateFields = res.data.contractMohaUpdateFields;
            contract.contractMohaFields = res.data.contractMohaVersionNewFields;
          } else {
            contract.contractMohaFields = res.data.contractMohaFields;
          }
        }
        let fileSizeUp = 0;
        contract.mainContractAttachments.forEach(element => {
          fileSizeUp = fileSizeUp + Number(element.fileSize);
        });
        this.createContractMohaService.fileSizeUp.next(fileSizeUp);
        console.log('contract detail', contract)
        if(this.flagCopy){
          contract.mainContractAttachments = []
        }
        // this.createContractMohaService.mainContractAttactment.next(contract.mainContractAttachments)
        this.createContractMohaService.fieldData = contract.fields ? contract.fields : null;
        this.createContractMohaService.tableModel = contract.tableModel ? contract.tableModel : null;
        this.createContractMohaService.contractMohaFields = contract.contractMohaFields ? contract.contractMohaFields : null;
        this.createContractMohaService.contractMohaUpdateFields = contract.contractMohaUpdateFields ? contract.contractMohaUpdateFields : null;
        this.createContractMohaService.customerMohaId = contract.customerMohaId ? contract.customerMohaId : null;
        if (contract.fields && contract.tableModel) {
          this.createContractMohaService.tableModel.rows = contract.tableModel.rows.map((item, index) => {
            if (!item.field) {
              item.field = contract.fields[index] ? contract.fields[index] : null;
            }
            return item;
          });
        }
        this.createContractMohaService.selectedServiceType.next(res.data.serviceType);
        this.createContractMohaService.document.next(contract);
        if(contract.contractSharePartners && contract.contractSharePartners.length > 0){
          let contractSharePartners = contract.contractSharePartners.map(item => {
            return {
              ...item,
              email: item.receiveEmail,
              name: item.receiveName,
              phone: item.receivePhone,
            }
          })
          this.createContractMohaService.recordsSharePartner.next(contractSharePartners)
        }

        if (contract.signatures && !this.flagCopy) {
          const signatures = contract.signatures;
          if (contract.signPositions) {
            signatures.map(sign => {
              if (sign.signature && sign.signature.positions) {
                sign.signature.positions.map(pos => {
                  const signPos = contract.signPositions.find(sp => sp.signPositionId === pos.signaturePositionId);
                  if (signPos) {
                    pos.x = signPos.x;
                    pos.y = signPos.y;
                    pos.width = signPos.width;
                    pos.height = signPos.height;
                  }
                })
              }
            });
          }
          this.createContractMohaService.signatureData.next(signatures);
        }

        if (contract.contractShares) {
          let recordInternalUsers = [];
          contract.contractShares.map(item => {
            const recordInternalUser = {
              email: item.receiveEmail ? item.receiveEmail : item.email,
              name: item.receiveName ? item.receiveName : item.name,
              id: item.receiveId,
              departmentId: item.departmentId,
              status: item.status,
              errorReason: item.errorReason,
              type: item.receiveType,
              representativeId: item.representativeId,
              representativeIsActive: item.representativeIsActive,
              departmentName: item.departmentName,
              departmentCode: item.departmentCode,
              userPosition: item.userPosition
            };
            recordInternalUsers.push(recordInternalUser);
          });
          this.createContractMohaService.recordsInternalUsers.next(recordInternalUsers)
        }

        this.valueSelect = contract.typeId ? contract.typeId : 0;
        this.createContractMohaService.createContractType.next(this.valueSelect);
        if (this.valueSelect === FileUploadType) {
          // this.currentUpdate = 1;
          // this.current = 2;
          // this.createContractMohaService.currentStep.next(2);
        } else if (contract.filePath && !this.flagCopy) {
          this.commonService.getViewPdfForDocument(contract.id).subscribe(
            resFile => {
              if (!resFile) {
                return;
              }
              this.commonService.readFile(resFile, (pdfSrc) => {
                this.createContractMohaService.pdfSrc.next(pdfSrc);
              });
              //merge 21511
              let infoFile = [];
              const reader = new FileReader();
              reader.readAsBinaryString(resFile);
              reader.onloadend = () => {
                let count = 0;
                let dataLoad:any = reader.result;
                let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
                if (match) {
                    count = match[1];
                } else {
                    count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length;
                }
                infoFile.push({
                    numberPage: Number(count),
                    size: resFile.size
                })
                this.createContractMohaService.infoFile.next(infoFile);
              }
              //merge 21511
            }
          );
        }
        if (contract.documentTypeEnterpriseId && this.valueSelect === FormActionType) {
          this.documentTypeService.findById(contract.documentTypeEnterpriseId).subscribe(resDC => {
            if (!resDC || !resDC.data) {
              return;
            }
            this.createContractMohaService.selectedTemplate.next(resDC.data);
          });
        }
        if (contract.signPositions && !this.flagCopy ) {
          const signPositions = contract.signPositions.map(sign => {
            sign.positionX = sign.x;
            sign.positionY = sign.y;
            sign.widthRectangle = sign.width;
            sign.heightRectangle = sign.height;
            sign.pageIndex = sign.pageNumber;
            return sign;
          });
          this.createContractMohaService.signPositions.next(signPositions);
        }
        if (contract.contractCodePositions && !this.flagCopy && this.valueSelect === 1) {
          const contractCodePositions = contract.contractCodePositions.map(sign => {
            sign.positionX = sign.x;
            sign.positionY = sign.y;
            sign.widthRectangle = sign.width;
            sign.heightRectangle = sign.height;
            sign.pageIndex = sign.pageNumber;
            return sign;
          });
          this.createContractMohaService.contractCodePositions.next(contractCodePositions);
        }
        if (this.flagCopy) {
          delete contract.filePath;
          delete contract.fileNameUpdate;
          delete contract.fileSizeUpdate;
          delete contract.documentTypeEnterpriseId;
          delete contract.signPositions;
        }
      });
    }

  }

    // Doanh nghiệp mua Dịch vụ
    getDataCountNumberDocumentOfEnterpriseByService() {
      this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(
        response => {
          console.log('ENTERPRISE BY SERVICE:', response.data);
          this.biggerThan10MBFileSize = response.data.biggerThan10MBFileSize;
          this.isBuyContract10Mb = response.data.isBuyContract10Mb;
          this.isBuyContract1Mb = response.data.isBuyContract1Mb;
          this.createContractMohaService.isBuyContract10Mb.next(this.isBuyContract10Mb);
          this.createContractMohaService.isBuyContract1Mb.next(this.isBuyContract1Mb);
          this.createContractMohaService.biggerThan10MBFileSize.next(this.biggerThan10MBFileSize);
          this.getMaxSize(response.data.biggerThan10MBFileSize);
        }
      );
    }

  getMaxSize(biggerThan10MBFileSize: number){
    const id = localStorage.getItem('enterpriseId')
    this.digitalCertificateService.getPermissionHSM(id).subscribe(res => {
      if(res && res.success){
        this.maxSize = res.data.maxSize > 0 ? res.data.maxSize : this.size10MB;
        this.maxSizeSystem = res.data.maxSizeSystem ? res.data.maxSizeSystem : this.size150MB;
        this.maxPerMainFile = res.data.maxPerMainFile ? res.data.maxPerMainFile : this.size150MB;
        this.maxPerAttachFile = res.data.maxPerAttachFile ? res.data.maxPerAttachFile : this.size150MB;
        this.createContractMohaService.configSizeApprove.next(res.data.approveContractLight);
        this.createContractMohaService.configPageSign.next(res.data.pageContractLight);
        this.createContractMohaService.configNumberPosition.next(res.data.numberPositionSignContractLight);

        if (!this.isBuyContract10Mb && this.isBuyContract1Mb) {
          this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.size1MB / 1024 / 1024)));
        } else {
          this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)));
        }
        this.createContractMohaService.maxSizeSystem.next(this.maxSizeSystem);
        this.createContractMohaService.maxPerMainFile.next(this.maxPerMainFile);
        this.createContractMohaService.maxPerAttachFile.next(this.maxPerAttachFile);
      }
    })
  }

  subscribeData() {
    this.subscriptions.add(
      this.createContractMohaService.isRecordsPartySignValid.asObservable().subscribe(rs => {
        if (rs) {
          // sau khi validate dữ liệu từ 2 component con
          // this.createContractMohaService.currentStep.next(1);
          // this.current = 1;
          if (this.current === 0) {
            if((this.createContractMohaService.recordsPartySign.getValue() && this.createContractMohaService.recordsPartySign.getValue().length) &&
              !this.createContractMohaService.checkHasOneCustomerType10000()){
              this.toastr.error(this.message.getMessage('add_document_moha.labor_contract_requires_individual_employee'))
              return;
            }
            if (this.valueSelect === FormActionType) {
              this.checkDifference(this.createContractMohaService.cacheRecordParty, this.createContractMohaService.recordsPartySign.getValue(), () => {
                this.current = 1;
                this.createContractMohaService.currentStep.next(this.current);
                this.createContractMohaService.cacheRecordParty = JSON.parse(JSON.stringify(this.createContractMohaService.recordsPartySign.getValue()));
              });
            } else {
              this.current = 2;
              this.createContractMohaService.currentStep.next(this.current);
            }
          } else if (this.current === 3) { // cuongnm change current step 2 -> 3
            // lưu hợp đồng
            if (this.valueSelect === FormActionType) {
              if (this.valueSelect === FormActionType && this.createContractMohaService.changeFileOutput) {
                // const content = this.message.getMessage('messages.use_all_file_and_template');
                // const dialog = this.dialog.open(WarningComponent, {
                //   width: '40%',
                //   data: content
                // });
                // dialog.afterClosed().subscribe(ref => {
                //   if (ref) {
                //     this.checkDifference(this.createContractMohaService.cacheRecordParty, this.createContractMohaService.recordsPartySign.getValue(), () => {
                //       this.createContractMohaService.cacheRecordParty = JSON.parse(JSON.stringify(this.createContractMohaService.recordsPartySign.getValue()));
                //       this.saveContract();
                //     }, 'save');
                //   }
                // });
                this.checkDifference(this.createContractMohaService.cacheRecordParty, this.createContractMohaService.recordsPartySign.getValue(), () => {
                  this.createContractMohaService.cacheRecordParty = JSON.parse(JSON.stringify(this.createContractMohaService.recordsPartySign.getValue()));
                  this.saveContract();
                }, 'save');
              } else {
                this.checkDifference(this.createContractMohaService.cacheRecordParty, this.createContractMohaService.recordsPartySign.getValue(), () => {
                  this.createContractMohaService.cacheRecordParty = JSON.parse(JSON.stringify(this.createContractMohaService.recordsPartySign.getValue()));
                  this.saveContract();
                }, 'save');
              }
            } else {
              this.saveContract();
            }
          }

          this.createContractMohaService.isSubmitData.next(false);
          this.createContractMohaService.isGeneralInfoValid.next(false);
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.isSuccessStep2.subscribe(ref => {
        if (ref) {
          this.current = 2;
          this.createContractMohaService.currentStep.next(this.current);
        }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.isSuccessStep3.subscribe(ref => {
        if (ref) {
          this.current = 3;
          this.createContractMohaService.currentStep.next(this.current);
        }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.selectedTemplate.subscribe(ref => {
        if (ref && this.current === 2 && ref.code !== 'uploadFile') {
          this.createContractMohaService.pdfSrc.next(null);
          this.createContractMohaService.documentFileTemplate.next(null);
          this.createContractMohaService.tableModel = null;
          this.createContractMohaService.documentTemplate = null;
          this.createContractMohaService.fileExport = null;
          this.valueSelect = FormActionType;
          this.createContractMohaService.createContractType.next(FormActionType);
          this.current = 1;
          this.createContractMohaService.currentStep.next(this.current);
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.isChangeFile.subscribe(ref => {
        if (ref == true) {
          this.current = 0;
          this.createContractMohaService.currentStep.next(this.current);
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.createContractType.subscribe(ref => {
        if (ref) {
          this.valueSelect = ref;
        }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.saveDataTable.subscribe(ref => {
        if (!ref && this.current === 1) {
          this.current--;
          this.createContractMohaService.currentStep.next(this.current);
        }
      })
    );
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.createContractMohaService.recordsPartySign.next([]);
    this.createContractMohaService.recordsInternalUsers.next([]);
    this.createContractMohaService.recordsUserPerformSign.next([]);
    this.createContractMohaService.pdfSrc.next(null);
    this.createContractMohaService.signPositions.next([]);
    this.createContractMohaService.dataReferenceContract.next([]);
    this.createContractMohaService.dataDocumentParentNewUploadContractAttachments.next([]);
    this.createContractMohaService.checkFootNote.next(false);
    this.createContractMohaService.listDataCustomerApproveResize.next(null);
    this.createContractMohaService.currentTotalcapacityMainAttachments.next(null);
    localStorage.removeItem('forcusCode');
    // localStorage.removeItem('listDataCustomerApproveResize');
    this.createContractMohaService.resetData()
    this.subscriptions.unsubscribe();
  }

  onBtnUploadClick(e) {
    // if (this.panelDocumentComponent.valueSelect != FileUploadType) {
    //   // this.panelDocumentComponent.valueSelect = FileUploadType;
    //   this.panelDocumentComponent.pdfSrc = '';
    //   this.resetInput();
    // }
    //
    // this.panelDocumentComponent.getFile(e);
    // this.onClickSetColor('local');
    // this.reset();
  }

  onSelectedFormClick() {
    //
    const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
      width: '30%',
      disableClose: true,
      data: { mode: null, isDocumentMoha: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined') {
        console.log("Ma hop dong", result);
        this.isShowStep = true;
        this.valueSelect = FormActionType;
        this.createContractMohaService.selectedTemplate.next(result.data.documentTypeEnterprise);
        this.createContractMohaService.createContractType.next(FormActionType);
        // this.panelDocumentComponent.document.documentTypeEnterpriseId = result.data.documentTypeEnterprise.id;
        // if (this.panelDocumentComponent.valueSelect != FormActionType) {
        //   this.isFormChanging = true;
        //   this.panelDocumentComponent.valueSelect = FormActionType;
        // }
        // this.panelDocumentComponent.onChangeAutoCompletedDocumentType(result.data.documentTypeEnterprise);
        // this.isFormChanging = true;
        // this.onClickSetColor('server');
        // this.reset();
      }
    });
  }

  async onSelectedUpload(event) {
    await this.getFile(event);
    this.reset()
  }
  private reset() {
    this.inputUploadFile.nativeElement.value = "";
  }
  public async getFile(e) {
    if (typeof (FileReader) !== 'undefined') {
      // Laays danhsach tep type/size/mname/lasstModifined la cac truong du lieu cua file
      const files = e.target.files;
      if (files.length > 0) {
        this.arrFile = files;
      }
      let size = 0;
      const fileSave = [];
      const fileSrc = [];
      const fileAttach = []
      let error: 'type' | 'size' = null;
      for (let file of files) {
        if (file.type !== 'application/pdf') {
          error = 'type';
          break;
        } else if(file.size > this.maxPerMainFile) {
          error = 'size';
          break;
        } else{
          // if (file.size <= this.maxSize) {
            size += file.size;
            const fileName = file.name;
            const dotIndex = fileName.lastIndexOf('.');
            const namePart = fileName.substring(0, dotIndex);
            const extPart = fileName.substring(dotIndex + 1).toLowerCase();
            const newFileName  = `${namePart}.${extPart}`;
            file = new File([file], `${newFileName}`, { type: file.type });
            // Trar veefnoi dung tep neu la pdf
            const src = await this.checkContentTypeThenAddFile(file);
            if (src) {
              const nameFileSplit = file.name.substring(0, file.name.length - 4);
              const find = fileSave.find(item => {
                return item.name === file.name;
              });
              const specials = [
                '/', '.', '*', '+', '?', '|',
                '(', ')', '[', ']', '{', '}', '\\'
              ];
              const regSpe = new RegExp('(\\' + specials.join('|\\') + ')', 'gim');
              const nameFileReg = nameFileSplit.replace(regSpe, '\\$1');
              const sameName = fileSave.filter(item => {
                return new RegExp(nameFileReg + '\\([0-9]{1,}\\)\.' + 'pdf').test(item.name);
              });
              const number = sameName.map(item => {
                const listNumber = item.name.match(/\([0-9]{1,}\)/g);
                return listNumber.length ? listNumber[listNumber.length - 1].replace('(', '').replace(')', '') : null;
              });
              if (find && !number.length) {
                file = new File([file], `${nameFileSplit}(1).pdf`, { type: file.type });
              } else if (find && number.length) {
                const numbers = Array.from({ length: 100 }, (v, i) => i + 1);
                let index;
                for (const iterator of numbers) {
                  if (!number.includes(iterator.toString())) {
                    index = iterator;
                    break;
                  }
                }
                file = new File([file], `${nameFileSplit}(${index}).pdf`, { type: file.type });
              }
              file.id = encodeURIComponent(file.name);
              fileSave.push(file);
              fileSrc.push(src);
              const path = +new Date() + ""
              fileAttach.push({
                file: file,
                src: src,
                path: path
              })
            } else {
              error = 'type';
              break;
            }
          // }
          //  else {
          //   error = 'size';
          //   break;
          // }
        }
      }
      this.fileUploadSize = size;
      this.createContractMohaService.currentTotalcapacityMainAttachments.next(size);
      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              if (this.pdfSrc == null || this.pdfSrc.length === 0) {
                this.valueSelect = null;
              }
            }
            break;
          case 'size':
            if (!this.toastr.findDuplicate(this.message.getMessage('validation.max_size_file_upload'), true, true)) {
              this.toastr.error(this.message.getMessage('validation.max_size_file_upload').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024))));
              if (this.pdfSrc == null || this.pdfSrc.length === 0) {
                this.valueSelect = null;
              }
            }
            break;
          default:
            break;
        }
      // } else if (size > this.maxSize) {
      //   if (!this.toastr.findDuplicate(this.message.getMessage('validation.file_config'), true, true)) {
      //     this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSize / 1024 / 1024))));
      //     if (this.pdfSrc == null || this.pdfSrc.length === 0) {
      //       this.valueSelect = null;
      //     }
      //   }
      } else {
        //merge 21511
        let infoFile = [];
        files.forEach(file => {
            const reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onloadend = () => {
              let count = 0;
              let dataLoad:any = reader.result;
              let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
              if (match) {
                count = match[1];
              } else {
                count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g) ? dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length : 0;
              }
              if(count != 0){
                infoFile.push({
                  id: file.id,
                  numberPage: Number(count)
                })
                this.createContractMohaService.infoFile.next(infoFile);
              } else {
                const formData = new FormData;
                formData.append('file', file)
                this.blockUI.start()
                this.documentMohaService.getInfoFile(formData).pipe(finalize(()=>this.blockUI.stop())).subscribe(res => {
                  console.log(res);
                  if(res.success){
                    infoFile.push({
                      id: file.id,
                      numberPage: Number(res.data.numberPage) || 0
                    })
                    this.createContractMohaService.infoFile.next(infoFile);
                  } else {
                    this.toastr.error(res.message);
                  }
                })
              }
            }

        });

        if (this.isBuyContract1Mb && !this.isBuyContract10Mb) {
          if (this.fileUploadSize <= this.size1MB) {
              this.valueSelect = FileUploadType;
              this.createContractMohaService.fileUploadArray.next(fileSave);
              this.createContractMohaService.fileUploadSrc.next(fileSrc);
              this.createContractMohaService.mainContractAttactment.next(fileAttach);
              this.createContractMohaService.pdfSrc.next(fileSrc[0]);
              this.createContractMohaService.createContractType.next(FileUploadType);
              this.isShowStep = true;
          } else {
            this.toastr.error(this.message.getMessage('messages.uploaded_file_exceeds_the_allowed_1MB_capacity'));
            this.isShowFileError = true;
            return;
          }
        } else {
          if (this.fileUploadSize <= this.size10MB) {
            if (this.fileUploadSize === 0) {
              return;
            }
            this.valueSelect = FileUploadType;
            this.createContractMohaService.fileUploadArray.next(fileSave);
            this.createContractMohaService.fileUploadSrc.next(fileSrc);
            this.createContractMohaService.mainContractAttactment.next(fileAttach);
            this.createContractMohaService.pdfSrc.next(fileSrc[0]);
            this.createContractMohaService.createContractType.next(FileUploadType);
            this.isShowStep = true;
          } else if (this.fileUploadSize > this.size10MB && this.fileUploadSize <= this.maxSizeSystem) {
            const residualCapacity = this.fileUploadSize - this.size10MB;
            if (!this.biggerThan10MBFileSize) {
              this.toastr.error(this.message.getMessage('messages.uploaded_files_exceed'));
              this.isShowFileError = true;
              return;
            } else {
              if (this.biggerThan10MBFileSize >= residualCapacity) {
                this.valueSelect = FileUploadType;
                this.createContractMohaService.fileUploadArray.next(fileSave);
                this.createContractMohaService.fileUploadSrc.next(fileSrc);
                this.createContractMohaService.mainContractAttactment.next(fileAttach);
                this.createContractMohaService.pdfSrc.next(fileSrc[0]);
                this.createContractMohaService.createContractType.next(FileUploadType);
                this.isShowStep = true;
              } else {
                this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
                this.isShowFileError = true;
                return;
              }
            }
          } else {
            if (!this.biggerThan10MBFileSize) {
              this.toastr.error(this.message.getMessage('messages.uploaded_files_exceed'));
              this.isShowFileError = true;
              return;
            } else {
              this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
              this.isShowFileError = true;
              return;
            }
          }
        }
        //merge 21511

      }
      // this.reset();
    }
    return true;
  }

  private async checkContentTypeThenAddFile(file: File): Promise<any> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      })
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  onClickBtnCancel() {
    if (!this.createContractMohaService.isDirty && !this.createContractMohaService.changeFileOutput) {
      this.show = false;
      this.createContractMohaService.resetData();
      this.handsontableService.dirty.next(false);
      this.router.navigate(['/home-enterprise/new-document-moha/'])
      return;
    }
    let message;
    if (this.current === 0) {
      message = this.message.getMessage('messages.cancel_create_contract_step1');
    } else {
      message = this.message.getMessage('messages.cancel_create_contract_step2');
    }
    const confirmDialog = this.dialog.open(WarningComponent, {
      width: '350px',
      data: message
    });
    confirmDialog.afterClosed().subscribe(ref => {
      if (ref) {
        this.show = false;
        this.createContractMohaService.resetData();
        this.router.navigate(['/home-enterprise/new-document-moha/'])
      }
    });
  }

  prev() {
    if (this.current === 1) {
      this.createContractMohaService.saveDataTable.next(true);
      return;
    }
    if (this.current >= 0) {
      if (this.current >= 2 && this.valueSelect === FileUploadType) {
        this.createContractMohaService.isBack.next(true);
        if(this.current == 2){
          this.current = 0;
          this.createContractMohaService.saveStep3.next(false)
        }
        else{
          this.current = 2;
        }
      } else if (this.current === 3) { // cuongnm change step 2 -> 3
        this.handsontableService.dirty.next(false);
        this.createContractMohaService.isBack.next(true);
        if(this.valueSelect === FormActionType){
          this.createContractMohaService.pdfSrc.next(this.createContractMohaService.fileUploadSrc.getValue()[0])
        }
        setTimeout(() => {
          this.checkDifference(this.createContractMohaService.cacheRecordParty,
            this.createContractMohaService.recordsPartySign.getValue(), () => {
              this.createContractMohaService.currentStep.next(this.current - 1);
              this.current--;
              this.createContractMohaService.cacheRecordParty = JSON.parse(JSON.stringify(this.createContractMohaService.recordsPartySign.getValue()));
            }, 'back');
        }, 100);
      } else {
        if(this.current == 2 && this.valueSelect === FormActionType){
          this.createContractMohaService.saveStep3.next(false)
        }
        this.current--;
      }
    }
    this.createContractMohaService.currentStep.next(this.current);
  }

  next() {
    if (this.current <= 3) {
      if (this.current === 0) {
        if(this.createContractMohaService.isInvalidSetPartyFlow.getValue()){
          return;
        }
        if(this.createContractMohaService.errorSignEnterprise){
          return;
        }
        if(this.createContractMohaService.errorSignEnterprise2){
          this.toastr.error(this.message.getMessage('validation.error_customer_type_2'));
          return;
        }
        if(this.createContractMohaService.errorSignEnterprise3){
          return;
        }
        this.createContractMohaService.validateData();
        const fileSrc = this.createContractMohaService.fileUploadSrc.getValue();
        this.createContractMohaService.pdfSrc.next(fileSrc[0]);
      } else if (this.current === 1) {
        this.createContractMohaService.validateData();
        this.createContractMohaService.exportFile();
      }
      else if (this.current === 2) {
        // this.createContractMohaService.validateData();
        this.createContractMohaService.saveStep3.next(true);
        if(!this.createContractMohaService.isSuccessStep3.getValue() || this.createContractMohaService.getErrorMessageStep3()){
          if(this.createContractMohaService.getErrorMessageStep3()){
            this.toastr.error(this.message.getMessage(this.createContractMohaService.getErrorMessageStep3()))
            return;
          }
          return;
        }
      }
      else {
        this.current++;
      }
    }
    // if (this.current === 1) {
    //   // validate data
    //   this.createContractMohaService.validateData();
    // }
    // if (this.current === 1) {
    //   this.generalFormInfoComponent.submitData();
    // }
    this.createContractMohaService.currentStep.next(this.current);
  }

  gotoSignPage() {

  }

  onClickNext() {
    if (this.isSavingData) {
      return;
    }
    this.isSavingData = true;
    // this.blockUI.reset();
    // this.blockUI.start('');
    setTimeout(() => {
      this.isSavingData = false;
    }, 200);
    this.createContractMohaService.validateData();
  }

  onClickBtnSave(isSaveDraft: boolean) {
    if (!isSaveDraft) {
      if (this.userType == 1 || this.userType == 2) {
        this.documentMohaService.getCheckVneidConfirm(this.contractId, true, true).subscribe(res => {
          if (res.success) {
            this.dataCheckVneid = res.data;
            switch (this.dataCheckVneid.typeVerify) {
              case 'SHARE_INFO': 
                this.openRequestConfirmIdentity(isSaveDraft);
                break;
              case 'FACE_MATCH': 
                this.openRequestConfirmIdentity(isSaveDraft);
                break;
              case 'VERIFIED': 
                this.continueStartSignFlow(isSaveDraft);
                break;
            }
          } else {
            this.toastr.error(res.message);
          }
        })
      } else {
        this.continueStartSignFlow(isSaveDraft);
      }
      
    } else {
      this.continueStartSignFlow(isSaveDraft);
    }
  }

  private openRequestConfirmIdentity(isSaveDraft: boolean): void {
    const dialogRef = this.dialog.open(RequestConfirmIdentityComponent, {
      width: this.deviceService.isMobile() ? '100%' : '640px',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.openEnterIdentityVneid(isSaveDraft);
      }
    });
  }

  private openEnterIdentityVneid(isSaveDraft: boolean): void {
    const dialogRef = this.dialog.open(EnterIdentityVneidComponent, {
      panelClass: 'sign-authentication',
      width: '1080px',
      maxWidth: '90vw',
      height: 'auto',
      disableClose: true,
      data: {
        documentId: this.contractId,
        dataCheckVneid: this.dataCheckVneid,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        this.openRequestConfirmIdentity(isSaveDraft);
        return;
      } else {
        this.continueStartSignFlow(isSaveDraft);
      }
    });
  }

  continueStartSignFlow(isSaveDraft: boolean) {
    if (!isSaveDraft) {
      this.checkTindy(() => {
        this.handleSave(isSaveDraft)
      })
    } else {
      this.handleSave(isSaveDraft);
    }
    //merge 21511
  }

  handleSave(isSaveDraft: boolean) {
    this.asEnterpriseService.getEnterpriseCheckResources().subscribe((rs) => {
      if (rs && rs.code == 200) {
        console.log("rs", rs);
        const isBuyContract1Mb = rs.data.isBuy1MB;
        const isBuyContract10Mb = rs.data.isBuy10MB;
        const configSizeApprove = this.createContractMohaService.configSizeApprove.getValue();
        const configPageSign = this.createContractMohaService.configPageSign.getValue();
        const configNumberPosition = this.createContractMohaService.configNumberPosition.getValue();
        let signPositions = [];
        let signPositionsFile = []
        if (this.valueSelect === 0) {
          signPositions = this.createContractMohaService.signatureData.getValue();
          signPositionsFile = this.createContractMohaService.signPositions.getValue();
        } else {
          signPositions = this.createContractMohaService.signPositions.getValue();
        }
        const recordPerformSigns = this.createContractMohaService.recordsUserPerformSign.getValue();
        const recordsPartySign = this.createContractMohaService.recordsPartySign.getValue();
        const fileUploadArray:any = this.createContractMohaService.fileUploadArray.getValue();
        const infoFile = this.createContractMohaService.infoFile.getValue();
        let isMorePosition: boolean = false;
        let isMoreApproveCusAndPosition: boolean = false;
        let isMoreNumberPage: boolean = false;
        let uploadSize = 0;
        const dataUserApproves = recordPerformSigns.filter(user => user.role == '2');
        const userEntSign = recordPerformSigns.filter(user => user.role == '1');
        if (this.valueSelect === 0) {
          if (signPositions) {
            let numberPositionCheck = 0;
            const dataSignPostions = signPositions.filter(position => position.customerId || position.userId);
            const dataSignPostionsFile = signPositionsFile.filter(position => position.customerId || position.userId);
            // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
            for (let a = 0; a < recordsPartySign.length; a++) {
              if (!recordsPartySign[a].isCreatedSide) {
                if (recordsPartySign[a].customerApproves) {
                  if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
                    isMoreApproveCusAndPosition = true;
                    break;
                  } else {
                    for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                      const positionOfCustomerSign = dataSignPostions.filter(positon => positon.userId === recordsPartySign[a].customerId);
                      const positionOfEnterpriseSign = dataSignPostionsFile.filter(positon => positon.userId === recordsPartySign[a].customerId);
                      const positionOfCustomer = dataSignPostions.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                      if (positionOfCustomer.length + positionOfEnterpriseSign.length + positionOfCustomerSign.length > configNumberPosition) {
                        isMoreApproveCusAndPosition = true;
                        break;
                      }
                    }
                  }
                }
              }
            }
            // Kiem tra so luong chan ky cua chu the Ben Lap
            for (let i = 0; i < dataSignPostions.length; i++) {
              if (dataSignPostions[i].signature.object == "ENTERPRISE" || dataSignPostions[i].signature.object == "ENTERPRISEAPPROVER" ) {
                numberPositionCheck = numberPositionCheck + dataSignPostions[i].signature.positions.length + dataSignPostionsFile.filter(positon => userEntSign[i] && ( positon.enterpriseId === userEntSign[i].enterpriseId ||  positon.enterpriseId === userEntSign[i].enterpriseSignId)).length;
                if (numberPositionCheck > configNumberPosition) {
                  isMorePosition = true;
                  break;
                }
              }
            }
            // for (let i = 0; i < dataSignPostions.length; i++) {
            //     if (dataSignPostions[i].signature.object === "CUSTOMER") {
            //       if (dataSignPostions[i].signature.positions.length > configNumberPosition) {
            //         isMorePosition = true;
            //         break;
            //       }
            //     } else {
            //       numberPositionCheck = numberPositionCheck + dataSignPostions[i].signature.positions.length;
            //       if (numberPositionCheck > configNumberPosition) {
            //         isMorePosition = true;
            //         break;
            //       }
            //     }
            // }
          }
          for (let index = 0; index < fileUploadArray.length; index++) {
            const fileInfo = infoFile && infoFile.find(file => file.id === fileUploadArray[index].id) ;
            if ((fileInfo && fileInfo.numberPage > configPageSign) || (this.createContractMohaService.infoFileTemplate.getValue() && this.createContractMohaService.infoFileTemplate.getValue().numberPage > configPageSign)) {
              isMoreNumberPage = true;
              break;
            }
          }
          for (let index = 0; index < fileUploadArray.length; index++) {
            uploadSize = uploadSize + fileUploadArray[index].size
          }
        } else {
          let listFileIds = fileUploadArray.map(file => file.id);
          const filteredList = signPositions.filter(item => listFileIds.includes(item.fileId));
          for (let i = 0; i < userEntSign.length; i++) {
            const positionOfEnterprises = filteredList.filter(positon => positon.enterpriseId === userEntSign[i].enterpriseId);
            if (positionOfEnterprises.length > configNumberPosition) {
              isMorePosition = true;
              break;
            }
          }
          for (let j = 0; j < recordsPartySign.length; j++) {
            const positionOfEnterprises = filteredList.filter(positon => positon.customerId === recordsPartySign[j].customerId);
            if (positionOfEnterprises.length > configNumberPosition) {
              isMorePosition = true;
              break;
            }
          }
          // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
          for (let a = 0; a < recordsPartySign.length; a++) {
            if (!recordsPartySign[a].isCreatedSide) {
              if (recordsPartySign[a].customerApproves) {
                if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
                  isMoreApproveCusAndPosition = true;
                  break;
                } else {
                  for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                    const positionOfCustomerSign = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerId);
                    const positionOfCustomer = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                    if (positionOfCustomer.length + positionOfCustomerSign.length > configNumberPosition) {
                      isMoreApproveCusAndPosition = true;
                      break;
                    }
                  }
                }
              }
            }
          }
          for (let index = 0; index < fileUploadArray.length; index++) {
            const fileInfo = infoFile.find(file => file.id === fileUploadArray[index].id);
            if (fileInfo && fileInfo.numberPage > configPageSign) {
              isMoreNumberPage = true;
              break;
            }
          }
          for (let index = 0; index < fileUploadArray.length; index++) {
            uploadSize = uploadSize + fileUploadArray[index].size
          }
        }

        if (isBuyContract10Mb && !isBuyContract1Mb) {
            this.handlePassValidateSave(isSaveDraft);
        } else if (!isBuyContract10Mb && isBuyContract1Mb) {
          if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB) {
            this.handlePassValidateSave(isSaveDraft);
          } else {
            this.toastr.error(this.message.getMessage('messages.unable_to_create_1MB_contract'));
            return;
          }
        } else {
          if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB && !this.isUpdate) {
            if (rs.data.isQuantity1MB && rs.data.isExpire1MB) {
              this.handlePassValidateSave(isSaveDraft);
            } else {
              if (rs.data.isQuantity10MB && rs.data.isExpire10MB) {
                let message = 'messages.want_to_continue_creating_and_using_the_10MB';
                const dialogRe = this.dialog.open(WarningComponent, {
                  width: '500px',
                  data: this.message.getMessage(message),
                });
                dialogRe.afterClosed().subscribe(rs => {
                  if (rs) {
                    this.handlePassValidateSave(isSaveDraft);
                  }
                });
              } else {
                this.toastr.error(this.message.getMessage('messages.document_resource_has_run_out'));
                return;
              }
            }
          } else {
            this.handlePassValidateSave(isSaveDraft);
          }
        }
      }
    });
  }
//merge 21511
  handlePassValidateSave(isSaveDraft: boolean) {
    this.isSaveDraft = isSaveDraft;
    let invalidForm: boolean = false;
    this.createContractMohaService.isInvalidFieldTypeContract.subscribe((res) =>
      invalidForm = res
    );
    if (invalidForm) {
      this.createContractMohaService.validateData();
    } else {
      if (isSaveDraft) {
        this.saveProcess();
      } else {
        let document = this.createContractMohaService.document.getValue();
        let message = 'messages.confirm_start_flow';
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '500px',
          data: this.commonService.format(this.message.getMessage(message), document.name)
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.saveProcess();
          }
        });
      }
    }
  }

  saveProcess() {
    const signatures: any[] = this.createContractMohaService.signatureData.value;
    const users = this.createContractMohaService.recordsPartySign.getValue();
    const customers = users.filter(user => {
      return !user.isCreatedSide
    });
    let userSign = 0;
    let isCustomerId;
    if (signatures) {
      signatures.forEach(item => {
        if (item.signature.object === 'CUSTOMER') {
          if (item.customerId) {
            isCustomerId = true;
            userSign++;
          } else if (customers.length > 0) {
            isCustomerId = false;
          } else {
            isCustomerId = true;
          }
        }
      });

      if (signatures.length > 2 && userSign < customers.length) {
        isCustomerId = false;
      } else {
        isCustomerId = true;
      }
    }
    this.createContractMohaService.isSignatureConfiguration.next(null);
    if ((this.valueSelect === 1 && this.createContractMohaService.signPositions.getValue() && this.createContractMohaService.signPositions.getValue().length > 0)
      || (this.valueSelect !== 1 && isCustomerId)) {
      if (this.isSavingData) {
        return;
      }
      this.isSavingData = true;
      // this.blockUI.reset();
      // this.blockUI.start('');
      setTimeout(() => {
        this.isSavingData = false;
      }, 200);

      this.createContractMohaService.isSignatureConfiguration.next(true);
      this.createContractMohaService.validateData();
    } else {
      this.createContractMohaService.isSignatureConfiguration.next(false);
      this.dialog.open(WaringSignatureComponent, {
        data: this
      })
    }
  }

  fillFieldContractCodePositions(contractCodePositions: any[], mainContractAttachments) {
    return contractCodePositions.map(sign => {
      const fileDoc = mainContractAttachments.find(file => encodeURIComponent(file['fileName']) === sign['fileId']);
      if (fileDoc && fileDoc['id']) {
        sign['fileId'] = fileDoc['id'];
      }
      return sign;
    });
  }

  sortOrderUserSign(recordUserSign: any) {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...recordUserSign.filter(item => item.role === '2')];
    let RECORD_USER_SIGN = [...recordUserSign.filter(item => item.role === '1')];

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    return RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);
  }

  private async saveContract() {
    let document: DocumentDTO = DocumentDTO.build();
    let dataStep3 = this.getDataStep3()
    const recordsPartySign = this.createContractMohaService.recordsPartySign.getValue().map((data) => ({
      ...data,
      signConfig: JSON.stringify(data.signConfig)
    }));
    const recordsInternalUsers = this.createContractMohaService.recordsInternalUsers.getValue();
    const recordUserSign = this.createContractMohaService.recordsUserPerformSign.getValue().map((data) => ({
      ...data,
      signConfig: JSON.stringify(data.signConfig)
    }));;
    const documentInfor = this.createContractMohaService.document.getValue();
    delete documentInfor.backUpCode;
    document = Object.assign(document, documentInfor);
    document.contractMohaFields = dataStep3.contractMohaFields
    document.customerMohaId = dataStep3.customerMohaId;
    if (dataStep3.originalContract) {
      document.editProperty = dataStep3.adjustedContentSelected.type;
      document.contractMohaUpdateFields = dataStep3.contractMohaUpdateFields;
      document.originalContractId = dataStep3.originalContract;
    }
    document.enterpriseSign = recordsPartySign;
    // console.log(JSON.parse(localStorage.getItem("listDataCustomerApproveResize")));
    const CustomerApproveResize = this.createContractMohaService.listDataCustomerApproveResize.getValue();
    document.enterpriseSign.forEach(ele => {
      if(!ele.isCreatedSide){
        let resizeEnterpriseSign = [];
        if(CustomerApproveResize) {
          resizeEnterpriseSign = this.createContractMohaService.listDataCustomerApproveResize.getValue().filter(a => {
            return ((a && a.customerId == ele.customerId && ele.customerId) || (a && a.enterpriseId == ele.enterpriseId && ele.enterpriseId)) && a.role == 1
          });
        }

        if(typeof ele.signConfig == 'string'){
          const a  = JSON.parse(ele.signConfig);
          if(resizeEnterpriseSign.length > 0 && resizeEnterpriseSign[0].resize && CustomerApproveResize){
            ele.signConfig = '{"resize": true,"showImage":'+ a.showImage +'}'
          }
          else {
            ele.signConfig = '{"resize": false,"showImage":'+ a.showImage +'}'
          }
        }
        else {
          if(resizeEnterpriseSign.length > 0 && resizeEnterpriseSign[0].resize && CustomerApproveResize){
            ele.signConfig = '{"resize": true,"showImage":'+ ele.signConfig.showImage +'}'
          }
          else {
            ele.signConfig = '{"resize": false,"showImage":'+ ele.signConfig.showImage +'}'
          }
        }
      }

      if(ele.isSetupSignFlow){
        if(ele.customerApproves){
          if(ele.customerApproves.length > 0){
            ele.customerApproves.forEach(ala =>{
              let resize = [];
              if(CustomerApproveResize) {
               resize = this.createContractMohaService.listDataCustomerApproveResize.getValue().filter(a =>{
                return a.customerId == ala.customerId
              });}
              ala.fullName = ala.name
              ala.isSignDigitalCertificate = ala.CTS
              ala.order = ala.STT
              ala.role = '2'
              ala.taxCode = ala.taxCode
              if(resize.length > 0 && resize[0].resize && CustomerApproveResize){
                ala.signConfig = '{"resize": true,"showImage":'+ ala.image +'}'
              }
              else {
                ala.signConfig = '{"resize": false,"showImage":'+ ala.image +'}'
              }
              ala.customerId = ele.customerId
              const signPositions = this.createContractMohaService.signPositions.getValue().filter(ele =>{
                return ala.enterpriseId == ele.enterpriseId;
              });
              ala.positions = signPositions ? signPositions.map(sign => {
                let signPosition: any = {
                  pageNumber: sign.pageIndex ? sign.pageIndex : null,
                  x: sign.positionX !== null ? sign.positionX : null,
                  y: sign.positionY !== null ? sign.positionY : null,
                  width: sign.widthRectangle ? sign.widthRectangle : null,
                  height: sign.heightRectangle ? sign.heightRectangle : null,
                  fileId: sign.fileId ? sign.fileId : null
                }

                return signPosition;
              }) : null;
            })
          }
          else {
            ele.isSetupSignFlow = null
          }
        }
        else {
          ele.isSetupSignFlow = null
        }

      }
    })
    document.userSign = this.sortOrderUserSign(recordUserSign);
    document.userSign.forEach(ala =>{
      let resizeEnterpriseSign = [];
      if(CustomerApproveResize) {
       resizeEnterpriseSign = this.createContractMohaService.listDataCustomerApproveResize.getValue().filter(a =>{
        return a && a.userId == ala.userId
      });}
      if(typeof ala.signConfig == 'string'){
        const a  = JSON.parse(ala.signConfig);
        if(resizeEnterpriseSign.length > 0 && resizeEnterpriseSign[0].resize && CustomerApproveResize){
          ala.signConfig = '{"resize": true,"showImage":'+ a.showImage +'}'
        }
        else {
          ala.signConfig = '{"resize": false,"showImage":'+ a.showImage +'}'
        }
      }
      else {
        if(resizeEnterpriseSign.length > 0 && resizeEnterpriseSign[0].resize && CustomerApproveResize){
          ala.signConfig = '{"resize": true,"showImage":'+ ala.signConfig.showImage +'}'
        }
        else {
          ala.signConfig = '{"resize": false,"showImage":'+ ala.signConfig.showImage +'}'
        }
      }
      const a = JSON.parse(ala.signConfig);
      if(resizeEnterpriseSign.length > 0 && resizeEnterpriseSign[0].resize){
        ala.signConfig = '{"resize": true,"showImage":'+ a.showImage +'}'
      }
      else {
        ala.signConfig = '{"resize": false,"showImage":'+ a.showImage +'}'
      }
    })
    const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
    // debugger
    if (isOnAutoNumber) {
      document.code = document.code ? document.code : (this.createContractMohaService.configAutoNumber.getValue() ? this.createContractMohaService.configAutoNumber.getValue() : 'auto');
    } else {
      document.code = document.code ? document.code : 'auto';
    };
    if (recordsInternalUsers.length > 0) {
      let contractShares = [];
      recordsInternalUsers.map((item, index) => {
        const receive = { receiveId: item.id, receiveType: item.type };
        contractShares[index] = receive;
      })
      document.contractShares = contractShares;
    } else {
      document.contractShares = null;
    }
    if (document.editedLotContract === false) {
      document.editedLotContract = true;
    }
    if (this.createContractMohaService.documentFileTemplate.getValue()) {
      const templateFile = this.createContractMohaService.documentFileTemplate.getValue();
      document.templateFilePath = templateFile.file && templateFile.file.url ? templateFile.file.url : null;
    } else {
      document.templateFilePath = null;
    }
    document.fields = this.createContractMohaService.fieldData;
    document.signPositions = this.createContractMohaService.signPositions.getValue() ? this.createContractMohaService.signPositions.getValue().map(sign => {
      let signPosition: SignPosition = {
        pageNumber: sign.pageIndex ? sign.pageIndex : null,
        userId: sign.userId ? sign.userId : null,
        enterpriseId: sign.enterpriseId ? sign.enterpriseId : null,
        x: sign.positionX !== null ? sign.positionX : null,
        y: sign.positionY !== null ? sign.positionY : null,
        width: sign.widthRectangle ? sign.widthRectangle : null,
        height: sign.heightRectangle ? sign.heightRectangle : null,
        fileId: sign.fileId ? sign.fileId : null
      }

      if (sign.customerId) {
        signPosition = Object.assign(signPosition, {customerId: sign.customerId})
      }
      return signPosition;
    }) : null;
    if (document.signPositions) {
      document.signPositions = document.signPositions.filter(sign => {
        // TODO: bỏ kiểm tra enterpriseId
        const check = recordsPartySign.find(item => item.enterpriseId ? item.enterpriseId === sign.enterpriseId : item.customerId === sign.customerId);
        // const check = true
        let checkCusApprove = [];
        // if(!check){
        //   recordsPartySign.forEach(ala =>{
        //     if(ala.customerApproves){
        //       const a = ala.customerApproves.find(x => {return x.userId == sign.userId});
        //       if(a){
        //         checkCusApprove.push(a);
        //       }
        //     }
        //   })
        // }
        return check ;
      });
    }
    if (this.createContractMohaService.signatureData.getValue()) {
      document.signatures = this.processSignatureData(this.createContractMohaService.signatureData.getValue(), recordsPartySign);
    } else {
      document.signatures = null;
    }
    if (this.valueSelect === FileUploadType) {
      document.jsonData = null;
      document.tableModel = null;
      document.templateFilePath = null;
    }
    if (this.createContractMohaService.fileExport && this.createContractMohaService.fileExport.type !== 'application/json' && this.createContractMohaService.isNewFileTag) {
      document.outputContentFile = this.createContractMohaService.fileExport;
    }
    if (this.valueSelect === FormActionType) {
      // debugger
      document.signatureResponses = this.createContractMohaService.signatureResponse;
    }
    if (this.flagCopy || !this.isUpdate && this.originalContract) {
      document.id = null;
      if (!this.isNegotiate) {
        document.negotiate = false;
      }
    }
    if(document.dataDocumentParent && document.dataDocumentParent.length > 0){
      document.dataDocumentParent.forEach(element => {
        delete element['status']
        delete element['isContractShare']
      })
    }

    document.contractSharePartners = this.createContractMohaService.recordsSharePartner.getValue()
    if (this.createContractMohaService.createContractType.getValue() == 1) {
      const fileNeedSave = this.createContractMohaService.fileUploadArray.getValue().filter((item: any) => {
        return item.id && item.id.includes('.pdf');
      });
      if (fileNeedSave.length > 0) {
        let fileNeedCheck = fileNeedSave.filter(item => this.createContractMohaService.contractCodePositions.getValue().map(x => x.fileId).includes(item['id']));
        this.documentMohaService.checkExistSignfileDocument(fileNeedCheck).subscribe(res => {
          if (res.success) {
            this.commonService.uploadFilesDocumentMoha(fileNeedSave).subscribe(rs => {
              if(rs && !rs.success){
                this.toastr.error(rs.message);
              }
              if(rs && rs.code == ErrorCode.MaxSizeError){
                this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
                this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
              }else{
                if (fileNeedSave.length === this.createContractMohaService.fileUploadArray.getValue().length) {
                  const dataMainAttachmentNew = [];
                  document.filePath = rs.data[0].path;
                  document.fileNameUpdate = rs.data[0].fileName;
                  document.fileSizeUpdate = rs.data[0].fileSize;
                  document.mainContractAttachments.forEach((mainAttachment, index) => {
                    rs.data.forEach(mainAttachmentNew => {
                      if(mainAttachment.fileName === mainAttachmentNew.fileName) {
                        dataMainAttachmentNew.push({
                          attachmentOrder: index,
                          ...mainAttachmentNew
                        });
                      }
                    });
                  });
                  document.mainContractAttachments = [...dataMainAttachmentNew];
                } else {
                  let mainContractAttachmentsNew = document.mainContractAttachments.filter(att => {
                    const findInFileUpload = this.createContractMohaService.fileUploadArray.getValue().find((file: any) => file.id === att.id);
                    if(!att.src)
                      return findInFileUpload;
                  });
                  const dataMainAttachmentNew = [];
                  mainContractAttachmentsNew = mainContractAttachmentsNew.concat(rs.data);
                  document.filePath = mainContractAttachmentsNew[0].path;
                  document.fileNameUpdate = mainContractAttachmentsNew[0].fileName;
                  document.fileSizeUpdate = mainContractAttachmentsNew[0].fileSize;
                  document.mainContractAttachments.forEach((mainAttachment, index) => {
                    mainContractAttachmentsNew.forEach((mainAttachmentNew2) => {
                      if(mainAttachment.fileName === mainAttachmentNew2.fileName) {
                        dataMainAttachmentNew.push({
                          attachmentOrder: index,
                          ...mainAttachmentNew2
                        });
                      }
                    })
                  });
                  document.mainContractAttachments = [...dataMainAttachmentNew];
                }
                document.signPositions = document.signPositions.map(sign => {
                  const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
                  if (fileDoc && fileDoc.id) {
                    sign.fileId = fileDoc.id;
                  }
                  return sign;
                });
                document.enterpriseSign.forEach(ele => {
                  if(ele.isSetupSignFlow){
                    ele.customerApproves.forEach(ala =>{
                      ala.positions = ala.positions.map(sign => {
                        const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
                        if (fileDoc && fileDoc.id) {
                          sign.fileId = fileDoc.id;
                        }
                        return sign;
                      });
                    })
                  }
                })
                this.saveDataWithAttachment(document, this.valueSelect);
              }
            });
          } else {
            if (String(res.code) === '0x002111') {
              this.toastr.error(res.message);
            }
          }
        });
      } else {
        let mainContractAttachmentsNew = document.mainContractAttachments.filter(att => {
          const findInFileUpload = this.createContractMohaService.fileUploadArray.getValue().find((file: any) => file.id === att.id);
          return findInFileUpload;
        });
        const dataMainAttachmentNew = [];
        document.filePath = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].path : null;
        document.fileNameUpdate = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].fileName : null;
        document.fileSizeUpdate = mainContractAttachmentsNew.length ? mainContractAttachmentsNew[0].fileSize : null;
        document.mainContractAttachments.forEach((mainAttachment, index) => {
          mainContractAttachmentsNew.forEach(mainAttachmentNew3 => {
            if(mainAttachment.fileName === mainAttachmentNew3.fileName) {
              dataMainAttachmentNew.push({
                attachmentOrder: index,
                ...mainAttachmentNew3
              });
            }
          });
        });
        document.mainContractAttachments = [...dataMainAttachmentNew];
        document.enterpriseSign.forEach(ele => {
          if(ele.isSetupSignFlow){
            ele.customerApproves.forEach(ala =>{
              ala.positions = ala.positions.map(sign => {
                const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
                if (fileDoc && fileDoc.id) {
                  sign.fileId = fileDoc.id;
                }
                return sign;
              });
            })
          }
        })
        this.saveDataWithAttachment(document, this.valueSelect);
      }
    } else if (document.outputContentFile) {
      const file = new File([document.outputContentFile], `${document.name}.pdf`, { type: 'application/pdf' })
      const fileNeedSave = this.createContractMohaService.fileUploadArray.getValue().filter((item: any) => {
        return item.id && item.id.includes('.pdf') && item.source !== "FORM";
      });
      const templateFile = (this.createContractMohaService.fileUploadArray.getValue().find((item: any) => item.source && item.source == "FORM" ))
      if (fileNeedSave.length > 0) {
            let fileNeedCheck = fileNeedSave.filter(item => this.createContractMohaService.contractCodePositions.getValue().map(x => x.fileId).includes(item['id']));
            this.documentMohaService.checkExistSignfileDocument(fileNeedCheck).subscribe(res => {
              if (res.success) {
                this.getFormFile(document, file, fileNeedSave, templateFile)
              } else {
                if (String(res.code) === '0x002111') {
                  this.toastr.error(res.message);
                }
              }
            })
      } else {
        this.getFormFile(document, file, '', '')
      }


    } else {
      if (this.valueSelect === FileUploadType) {
        document.mainContractAttachments = [];
      }
      document.enterpriseSign.forEach(ele => {
        if(ele.isSetupSignFlow){
          ele.customerApproves.forEach(ala =>{
            ala.positions = ala.positions.map(sign => {
              const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
              if (fileDoc && fileDoc.id) {
                sign.fileId = fileDoc.id;
              }
              return sign;
            });
          })
        }
      })
      this.saveDataWithAttachment(document, this.valueSelect);
    }
  }

  saveDataWithAttachment(document: DocumentDTO, type: number) {
    if(type === FormActionType ){
      const templateFile = document.mainContractAttachments.find(item => item.source == "FORM")
      if(templateFile && templateFile.id){
        document.signPositions = document.signPositions.filter(item => item.fileId !== templateFile.id)
      } else {
        const files = document.mainContractAttachments.filter(item => item.source != "FORM")
        if(files.length>0){
          document.signPositions = document.signPositions.filter(item => files.find(file => file.id == item.fileId))
        } else {
          document.signPositions = []
        }
      }
    }
    if (document.newUploadContractAttachments.length) {
      this.uploadFile(document, () => {
        if (type === FormActionType) {
          this.callApiSave(document);
        } else {
          this.callApiSaveFileDocument(document);
        }
      }, () => {
        if (type === FormActionType) {
          this.callApiSave(document);
        } else {
          this.callApiSaveFileDocument(document);
        }
      });
    } else {
      if (type === FormActionType) {
        document.enterpriseSign.forEach(ala =>{
          if(ala.customerApproves){
            if(ala.customerApproves.length > 0){
              ala.customerApproves.forEach(ele => {
                if(ele.contractUserId){
                  delete ele.contractUserId;
                }
              })
            }
          }
        })
        this.callApiSave(document);
      } else {
        document.enterpriseSign.forEach(ala =>{
          if(ala.customerApproves){
            if(ala.customerApproves.length > 0){
              ala.customerApproves.forEach(ele => {
                if(ele.contractUserId){
                  delete ele.contractUserId;
                }
              })
            }
          }
        })
        this.callApiSaveFileDocument(document);
      }
    }
  }

  callApiSave(document: DocumentDTO) {
    if (this.isSaveDraft && document.tempCode) {
      document.code = document.tempCode;
    }
    delete document.tempCode;
    if (document.id) {
      this.documentTypeService.findById(document.documentTypeEnterpriseId).subscribe(response => {
        // debugger
        document.signatureResponses = this.createContractMohaService.signatureResponse;
        if (response && response.data && response.data.status && response.data.relationStatus) {
          const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
          const refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
          if (isOnAutoNumber) {
            document['refreshContractCode'] = refreshContractCode;
          }
          delete document.outputContentFile;
          const newMainContractAttachments = [...document.mainContractAttachments]
          // newMainContractAttachments.push({
          //   active: true,
          //   attachmentOrder: 0,

          // })
          this.documentMohaService.updateDocumentByTemplate(document, this.documentCodeDuplicateHanlder.bind(this)).subscribe(rs => {
            if (!rs || !rs.success) {
              return;
            }
            this.show = false;
            if(this.isNegotiate || (this.isUpdate && this.createContractMohaService.document.getValue().negotiate && this.isSaveDraft)){
              this.saveContractWithNegotiate(document.id)
              return;
            }
            if (this.isSaveDraft) {
              this.toastr.success(this.message.getMessage('messages.save_draft_success'));
              this.show = false;
              // navigate to list screen.
              this.router.navigate(['/home-enterprise/new-document-moha/'], {
                // queryParams: navigatorParam
                queryParams: {}
              });
            } else {
              this.startSignFlow(document.id);
            }
            this.createContractMohaService.refreshContractCode.next(false);
          });
          this.isSaveDocumentFalse()
        } else {
          const dialog = this.dialog.open(WarningComponent, {
            width: '40%',
            data: this.message.getMessage('messages.use_inactive_template')
          });
          dialog.afterClosed().subscribe(ref => {
            if (ref) {
              const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
              const refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
              if (isOnAutoNumber) {
                document['refreshContractCode'] = refreshContractCode;
              }
              this.documentMohaService.updateDocumentByTemplate(document, this.documentCodeDuplicateHanlder.bind(this)).subscribe(rs => {
                if (!rs || !rs.success) {
                  return;
                }
                this.show = false;
                if(this.isNegotiate || (this.isUpdate && this.createContractMohaService.document.getValue().negotiate && this.isSaveDraft)){
                  this.saveContractWithNegotiate(document.id)
                  return;
                }
                if (this.isSaveDraft) {
                  this.toastr.success(this.message.getMessage('messages.save_draft_success'));
                  this.show = false;
                  // navigate to list screen.
                  this.router.navigate(['/home-enterprise/new-document-moha/'], {
                    // queryParams: navigatorParam
                    queryParams: {}
                  });
                } else {
                  this.startSignFlow(document.id);
                }
                this.createContractMohaService.refreshContractCode.next(false);
              });
              this.isSaveDocumentFalse()
            }
          });
        }
      });
    } else {
      document.cancelReason = null;
      document.cancelTime = null;
      document.finishDate = null;
      document.cancelUserFullName = null;
      this.createContractMohaService.selectedTemplate.asObservable().subscribe(rs => {
        if (rs) {

        }
      });
      const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
      if (isOnAutoNumber) {
        document['codeAuto'] = "";
      } else {
        document['codeAuto'] = document.code;
      }
      this.documentMohaService.createDocumentByTemplate(document, this.documentCodeDuplicateHanlder.bind(this)).subscribe(rs => {
        if (!rs || !rs.success) {
          return;
        }
        this.show = false;
        if(this.isNegotiate){
          this.saveContractWithNegotiate(rs.data)
          return;
        }
        if (this.isSaveDraft) {
          this.toastr.success(this.message.getMessage('messages.save_draft_success'));
          this.show = false;
          // navigate to list screen.
          this.router.navigate(['/home-enterprise/new-document-moha/'], {
            // queryParams: navigatorParam
            queryParams: {}
          });
        } else {
          this.startSignFlow(rs.data);
        }
        this.createContractMohaService.refreshContractCode.next(false);
      });
      this.isSaveDocumentFalse()
    }
  }

  callApiSaveFileDocument(document: DocumentDTO) {
    if (!document.mainContractAttachments || !document.mainContractAttachments.length) {
      this.blockUI.stop();
      this.toastr.error(this.message.getMessage('messages.error_contract'));
      this.choose_form = true;
      setTimeout(() => {
        this.choose_form = false;
      }, 5000)
      return;
    }
    if (!document.id) {
      document.cancelReason = null;
      document.cancelTime = null;
      document.cancelUserFullName = null;
      document.finishDate = null;
      const refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
      this.createContractMohaService.selectedTemplate.asObservable().subscribe(rs => {
        if (rs) {

        }
      });
      const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
      if (isOnAutoNumber) {
        document['codeAuto'] = "";
      } else {
        document['codeAuto'] = document.code;
      }
      document['contractCodePositions'] = this.createContractMohaService.contractCodePositions.getValue() ? this.createContractMohaService.contractCodePositions.getValue().map(sign => {
        const contractCodePosition = {
          pageNumber: sign.pageIndex ? sign.pageIndex : null,
          x: sign.positionX !== null ? sign.positionX : null,
          y: sign.positionY !== null ? sign.positionY : null,
          width: sign.widthRectangle ? sign.widthRectangle : null,
          height: sign.heightRectangle ? sign.heightRectangle : null,
          fontSize: sign.fontSize,
          fontFamily: sign.fontFamily,
          fontStyle: sign.fontStyle,
          fileId: sign.fileId ? sign.fileId : null
        }
        return contractCodePosition;
      }) : null;
      document['contractCodePositions'] = this.fillFieldContractCodePositions(document['contractCodePositions'], document.mainContractAttachments);
      delete document['messageAuthenCode'];
      delete document['messageAuthenDate'];
      delete document['mohaSendTime'];
      this.documentMohaService.addDocument(document, this.documentCodeDuplicateHanlder.bind(this)).subscribe(rs => {
        if (rs && rs.success) {
          this.show = false;
          if(this.isNegotiate){
            this.saveContractWithNegotiate(rs.data)
            return;
          }
          if (this.isSaveDraft) {
            this.toastr.success(this.message.getMessage('messages.save_draft_success'));
            // navigate to list screen.
            this.router.navigate(['/home-enterprise/new-document-moha/'], {
              // queryParams: navigatorParam
              queryParams: {}
            });
          } else {
            this.startSignFlow(rs.data);
          }
        } else if(rs.code == ErrorCode.MaxSizeError){
          this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
        }
        this.createContractMohaService.refreshContractCode.next(false);
      });
    } else {
      const isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
      const refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
      if (isOnAutoNumber) {
        document['refreshContractCode'] = refreshContractCode;
      }
      document['contractCodePositions'] = this.createContractMohaService.contractCodePositions.getValue() ? this.createContractMohaService.contractCodePositions.getValue().map(sign => {
        const contractCodePosition = {
          pageNumber: sign.pageIndex ? sign.pageIndex : null,
          x: sign.positionX !== null ? sign.positionX : null,
          y: sign.positionY !== null ? sign.positionY : null,
          width: sign.widthRectangle ? sign.widthRectangle : null,
          height: sign.heightRectangle ? sign.heightRectangle : null,
          fontSize: sign.fontSize,
          fontFamily: sign.fontFamily,
          fontStyle: sign.fontStyle,
          fileId: sign.fileId ? sign.fileId : null
        }
        return contractCodePosition;
      }) : null;
      document['contractCodePositions'] = this.fillFieldContractCodePositions(document['contractCodePositions'], document.mainContractAttachments);
      const fileNeedSave = this.createContractMohaService.fileUploadArray.getValue();
      let fileNeedCheck = fileNeedSave.filter(item => this.createContractMohaService.contractCodePositions.getValue().map(x => x.fileId).includes(item['id']));
      this.documentMohaService.checkExistSignfileDocument(fileNeedCheck).subscribe(res => {
        if (res.success) {
          this.commonService.uploadFilesDocumentMoha(fileNeedSave).subscribe(rs => {
            document.mainContractAttachments.forEach(item => {
              delete item.src
            })
            this.documentMohaService.updateDocumentUpdload(
              document,
              (rs) => {
                  this.show = false;
                  // navigate to list screen.
                  if(this.isNegotiate || (this.isUpdate && this.createContractMohaService.document.getValue().negotiate && this.isSaveDraft)){
                    this.saveContractWithNegotiate(document.id)
                    return;
                  }
                  if (this.isSaveDraft) {
                    this.toastr.success(this.message.getMessage('messages.save_draft_success'));
                    this.show = false;
                    // navigate to list screen.
                    this.router.navigate(['/home-enterprise/new-document-moha/'], {
                      // queryParams: navigatorParam
                      queryParams: {}
                    });
                  } else {
                    this.startSignFlow(document.id);
                  }

              },
              (err) => {
                // reload screen if deprecate version.
                // this.getDocumentById(this.document.id);
              },
              this.documentCodeDuplicateHanlder.bind(this)
            );
          });
        } else {
          if (String(res.code) === '0x002111') {
            this.toastr.error(res.message);
          }
        }
      });
    }
  }

  private getBase64File(file: Blob): any {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  /**
   * Check code document duplicate
   * @param rs data after request api
   */
  private documentCodeDuplicateHanlder(rs: any) {
    if (!rs.success) {
      if (String(rs.code) === '0x001703') {
        this.createContractMohaService.isDuplicateCode.next(true);
        const dialogRef = this.dialog.open(WarningComponent, {
          width: '30%',
          data: this.message.getMessage('validation.document_code_duplicate')
        });
        dialogRef.afterClosed().subscribe(rs => {
          if (rs) {
            localStorage.setItem('forcusCode','true');
            this.current = 0
            this.createContractMohaService.currentStep.next(this.current);
            // this.prev();
            this.dialog.closeAll();
          }
        });
      } else if (String(rs.code) === '0x001505') {
        this.documentInactiveHandler();
      } else if (String(rs.code) === '0x002015') {
        this.toastr.error(this.message.getMessage('messages.warning_out_of_contract_quantity'));
      } else if (String(rs.code) === '0x004209' && !this.isSaveDraft) {
        this.toastr.error(this.message.getMessage('messages.contract_not_exist'));
      } else if (String(rs.code) === '0x002309') {
        this.toastr.error(this.message.getMessage('messages.is_not_auto_contract'));
        this.createContractMohaService.isOnAutoNumber.next(false)
      }else if(rs.code == ErrorCode.MaxSizeError){
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
        this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
      } else if (String(rs.code) === ErrorCode.NotChangeContractCode) {
        this.dialog.open(WarningNotChangeContractCodeComponent, {
          width: '350px'
        }).afterClosed().subscribe(ref => {
          if (ref) {
            this.documentMohaService.getDocumentById(this.contractId).subscribe(res => {
              if (!res || !res.data || !res.data.contractDTO) {
                return;
              }
              const contract = res.data.contractDTO;
              console.log('contract detail', contract)
              this.createContractMohaService.document.next(contract);
              this.createContractMohaService.refreshContractCode.next(false);
              this.createContractMohaService.isOnAutoNumber.next(true);
            });
          }
        });
      } else if(String(rs.code) === ErrorCode.Account_Subscribe_File_Download_Capacity_resource) {
        this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
      } else if(String(rs.code) === ErrorCode.Account_No_Subscribe_File_Download_Capacity_resource) {
        this.toastr.error(this.message.getMessage('messages.account_No_Subscribe_File_Download_Capacity_resource'));
      }
      else {
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
      }
    }
  }

  private documentInactiveHandler() {
    this.toastr.error(this.message.getMessage('messages.confirm_use_inactive_template'));
    const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
      width: '30%',
      disableClose: true,
      data: { mode: null }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined') {
        this.createContractMohaService.recordsUserPerformSign.next([])
        this.createContractMohaService.selectedTemplate.next(result.data.documentTypeEnterprise);
      }
    });
  }

  uploadFile(document: DocumentDTO, successCallback?: () => void, noUpload?: () => void) {
    const fileUpload = document.newUploadContractAttachments.filter(
      element => element.name !== undefined || element.File != null && element.File !== undefined);

    const arrFileUpload = [];

    fileUpload.forEach(element => {
      if (element.File != null) {
        arrFileUpload.push(element.File);
      } else {
        arrFileUpload.push(element);
      }
    });

    if (arrFileUpload.length > 0) {
      this.documentMohaService.uploadMultiFileAttachForDocument(arrFileUpload)
        .subscribe(rs => {
          if(rs && rs.success){
            this.uploadFileSuccess(document, rs, successCallback);
          }else{
            this.toastr.error(rs.message);
            if(rs.code == ErrorCode.MaxSizeError){
              this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
            }
          }
        });
    } else {
      noUpload();
    }
  }

  // After upload success
  private uploadFileSuccess(document: DocumentDTO, rs, successCallback: (data) => void) {
    for (let i = 0; i < rs.data.length; i++) {
      const fileIndex = document.newUploadContractAttachments.findIndex(item => item.name && item.name === rs.data[i].fileName);
      if (fileIndex >= 0) {
        document.newUploadContractAttachments[fileIndex] = {...rs.data[i],allow: document.newUploadContractAttachments[fileIndex].allow};
      }
    }

    document.newUploadContractAttachments = document.newUploadContractAttachments.filter(
      arrAttachments => arrAttachments.fileName !== undefined);

    successCallback(document.newUploadContractAttachments);
  }


  canDeactivate() {
    if (!this.isShowStep || !this.show || (!this.createContractMohaService.isDirty && !this.createContractMohaService.changeFileOutput) || (!window.sessionStorage.getItem('token') && !window.localStorage.getItem('token'))) {
      this.clearData = true;
      return true;
    }
    let message;
    if (this.current === 0) {
      message = this.message.getMessage('messages.cancel_create_contract_step1');
    } else {
      message = this.message.getMessage('messages.cancel_create_contract_step2');
    }
    const confirmDialog = this.dialog.open(WarningComponent, {
      width: '40%',
      data: message
    });
    return confirmDialog.afterClosed().pipe(map(res => {
      if (res) {
        this.clearData = true;
        return true;
      } else {
        return false;
      }
    }), first());
  }

  checkDifference(dataOld: any, dataNew: any, func: any, type?: 'save' | 'back') {
    if (!dataOld) {
      func();
      return;
    }
    const dataTable = this.getDataUserFromDataTable();
    const createdSideOld = dataTable.createSide as any;
    const createdSideNew = dataNew.find(item => item.isCreatedSide);
    const partyOld = dataTable.listUser.filter(item => item.enterpriseId);
    const partyNew = dataNew.filter(item => !item.isCreatedSide);
    let isDiffenceCreateSide = false;
    let isDiffenceParty = false;

    const userHasChanged = [];
    if (createdSideOld && !createdSideNew) {
      const entepriseId = localStorage.getItem('enterpriseId');
      if (entepriseId && createdSideOld.enterpriseId && createdSideOld.enterpriseId !== entepriseId) {
        isDiffenceCreateSide = true;
      }
    }
    if (createdSideNew && createdSideOld && this.checkDifferenceObject(createdSideNew, createdSideOld)) {
      isDiffenceCreateSide = true;
    }

    if ((!partyNew.length && partyOld.length)) {
      isDiffenceParty = true;
      partyOld.forEach(item => {
        if (item.name) {
          userHasChanged.push(`'${item.name}'`);
        }
      })
    } else if (partyNew.length && partyOld.length) {
      for (const [index, item] of partyOld.entries()) {
        if (item.customerId) {
          const itemNew = partyNew.find(enterprise => enterprise.customerId === item.customerId);
          if (!itemNew || (itemNew && this.checkDifferenceObject(itemNew, item))) {
            isDiffenceParty = true;
            userHasChanged.push(`'${item.name}'`);
          }
        }
      }
    }
    let content;
    if (isDiffenceCreateSide && isDiffenceParty) {
      const strAdd = `'${createdSideOld.name}', ${userHasChanged.join(', ')}`;
      if (this.flagCopy && this.current === 0) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_all_record_party_copy'), strAdd).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (!type) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_all_record_party'), strAdd).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (type === 'back') {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_all_record_party_back'), strAdd).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      }
      content = this.commonService.format(this.message.getMessage('messages.change_all_record_party_save'), strAdd).replace(/&quot;/g, "'");
    } else if (isDiffenceCreateSide) {
      if (this.flagCopy && this.current === 0) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_create_side_copy'), `'${createdSideOld.name}'`).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (!type) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_create_side'), `'${createdSideOld.name}'`).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (type === 'back') {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_create_side_back'), `'${createdSideOld.name}'`).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      }
      content = this.commonService.format(this.message.getMessage('messages.change_create_side_save'), `'${createdSideOld.name}'`).replace(/&quot;/g, "'");
    } else if (isDiffenceParty) {
      if (this.flagCopy && this.current === 0) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_record_party_copy'), userHasChanged.join(', ')).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (!type) {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_record_party'), userHasChanged.join(', ')).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      } else if (type === 'back') {
        this.toastr.warning(this.commonService.format(this.message.getMessage('messages.change_record_party_back'), userHasChanged.join(', ')).replace(/&quot;/g, "'"), '', { timeOut: 7500 });
        func();
        return;
      }
      content = this.commonService.format(this.message.getMessage('messages.change_record_party_save'), userHasChanged.join(', ')).replace(/&quot;/g, "'");
    }
    if (content) {
      const dialog = this.dialog.open(WarningComponent, {
        width: '40%',
        data: content
      });
      dialog.afterClosed().subscribe(ref => {
        if (ref) {
          func();
        }
      });
    } else {
      func();
    }
  }

  checkDifferenceObject(object1: any, object2: any) {
    for (const key of Object.keys(object2)) {
      if (key !== 'email' && key !== 'phone' && key !== 'name') {
        continue;
      }
      if (object1[key] && object2[key] && object1[key] !== object2[key]) {
        return true;
      }
    }
    return false;
  }

  openSignatureDialog() {
    this.createContractMohaService.saveRecordParty.next(true);
    this.dialog.open(SignatureMohaDialogComponent, {
      width: '80%',
    });
  }

  processSignatureData(data: any, users: any) {
    const customers = users.filter(user => {
      return !user.isCreatedSide;
    });
    const signatureData = data.map(item => {
      if (item.signature) {
        const page = [];
        if (item.signature.positions) {
          item.signature.positions.forEach(pos => {
            if (pos.page && !page.includes(pos.page)) {
              page.push(pos.page);
            }
          });
        }
        item.signature.page = page.join(', ');
        if ((!item.signature.object || item.signature.object === 'CUSTOMER') && item.customerId) {
          const option = customers.find(cus => cus.customerId === item.customerId);
          if (!option) {
            item.customerId = null;
          }
        }
      }
      return item;
    });
    return signatureData;
  }

  getDataUserFromDataTable() {
    const tableModel = this.createContractMohaService.tableModel;
    const rows = tableModel && tableModel.rows ? tableModel.rows : [];
    const listUser = [];
    const createSide = {};
    rows.forEach(row => {
      const cellValue = row.cells && row.cells.value ? row.cells.value : null;
      this.getInfoUserInRow(cellValue, listUser, createSide);
      if (row.children) {
        row.children.forEach(child => {
          const cellValueChild = child.cells && child.cells.value ? child.cells.value : null;
          this.getInfoUserInRow(cellValueChild, listUser, createSide);
        })
      }
    });
    const listUsers = listUser.filter(user => {
      let checkHaveData: boolean = false;
      Object.keys(user).forEach(key => {
        if (key !== 'code' && user[key]) {
          checkHaveData = true;
        }
      });
      return checkHaveData;
    })
    return {
      createSide,
      listUser: listUsers
    }
  }

  getInfoUserInRow(cellValue: any, listUser: any, createSide: any) {
    if (cellValue && cellValue.dataType && cellValue.dataType.code === "tham_chieu_ben_khach_hang") {
      const key = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
      if (key && cellValue.relatedFieldCode) {
        let object = listUser.find(user => user.code === cellValue.relatedFieldCode);
        if (object) {
          object[key] = cellValue.value ? cellValue.value : null;
        } else {
          object = { code: cellValue.relatedFieldCode };
          object[key] = cellValue.value ? cellValue.value : null;
          listUser.push(object);
        }
      }
    }

    if (cellValue && cellValue.category && cellValue.category.code === 'customer') {
      let user = listUser.find(user => user.code === cellValue.code);
      if (user) {
        user.customerId = cellValue.valueId ? cellValue.valueId : null;
        user.name = cellValue.value ? cellValue.value : null;
      } else {
        user = { code: cellValue.code };
        user.customerId = cellValue.valueId ? cellValue.valueId : null;
        user.name = cellValue.value ? cellValue.value : null;
        listUser.push(user);
      }
    }

    if (cellValue && cellValue.dataType && cellValue.dataType.code === 'tham_chieu_ben_lap') {
      const key = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
      createSide.enterpriseId = cellValue.valueId;
      if (key) {
        createSide[key] = cellValue.value;
      }
    }
  }

  startSignFlow(id) {

    this.documentMohaService.sendStartSignFlow(id).subscribe(res => {
      if (res) {
        this.toastr.success(this.message.getMessage('messages.save_draft_start_signing_success'));
        // navigate to list screen.
        this.router.navigate(['/home-enterprise/new-document-moha/'], {
          // queryParams: navigatorParam
          queryParams: {}
        });
      }
    });
  }

  getFormFile(document, file, fileNeedSave, templateFile){
    const apiUploadFile = [
      this.commonService.uploadFileDocumentMoha(file, this.valueSelect == 1)
    ]
    if (fileNeedSave) {
      apiUploadFile.push(this.commonService.uploadFilesDocumentMoha(fileNeedSave))
    }
    forkJoin(apiUploadFile).subscribe(([rs, rs2]) => {
      if(rs && rs.code == ErrorCode.MaxSizeError){
        this.maxSize = rs.data > 0 ? rs.data : this.size10MB;
        this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
      }else if (rs.data) {
        document.filePath = rs.data.path;
        document.fileNameUpdate = rs.data.fileName;
        document.fileSizeUpdate = rs.data.fileSize;
        delete document.outputContentFile;
        const newMainContractAttachments = document.mainContractAttachments.map(item => {
          if(item.source && item.source == 'FORM'){
            delete item['src']
            if(!this.isUpdate) {
              delete item['id']
            }
            item.path = document.filePath
          }
          return item
        })
        document.mainContractAttachments = [...newMainContractAttachments]
        document.enterpriseSign.forEach(ele => {
          if(ele.customerApproves){
            ele.customerApproves.forEach(ala =>{
              const positions = document.signatures.filter(element =>{
                return element.userId == ala.userId
              })
              if(positions.length > 0){
                if(ala.positions.length == 0){
                  ala.positions = positions[0].signature.positions;
                } else{
                  const formFile = document.mainContractAttachments.find(item => item.source == 'FORM') || {id: ''}
                  const position = ala.positions.filter(item => item.fileId != formFile.id)
                  ala.positions = [...position, ...positions[0].signature.positions].map(item => {
                    if(!item.fileId){
                      item.fileId = formFile.id
                      return item
                    } else return item
                  })
                }
                document.signatures = document.signatures.map(element => {
                  if(element.signature.object == 'CUSTOMERAPPROVER' && element.userId == ala.userId && !element.customerId){
                    element.customerId = ele.customerId
                    return element
                  } else return element
                })
              }
            })
          }
        })
      }

      if(rs2){
        if(rs2 && !rs2.success){
          this.isSaveDocumentFalse()
          this.toastr.error(rs2.message);
        }
        if(rs2 && rs2.code == ErrorCode.MaxSizeError){
          this.maxSize = rs2.data > 0 ? rs2.data : this.size10MB;
          this.mesage = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.maxPerMainFile / 1024 / 1024)))
        }else{
          if (fileNeedSave.length === this.createContractMohaService.fileUploadArray.getValue().length) {
            const dataMainAttachmentNew = [];
            // document.filePath = rs2.data[0].path;
            // document.fileNameUpdate = rs2.data[0].fileName;
            // document.fileSizeUpdate = rs2.data[0].fileSize;
            document.mainContractAttachments.forEach((mainAttachment, index) => {
              rs2.data.forEach(mainAttachmentNew => {
                if(mainAttachment.fileName === mainAttachmentNew.fileName) {
                  dataMainAttachmentNew.push({
                    attachmentOrder: mainAttachment.attachmentOrder,
                    ...mainAttachmentNew
                  });
                }
                if (mainAttachment.source && mainAttachment.source == "FORM" && !dataMainAttachmentNew.map(item => item.source).includes('FORM')){
                  delete mainAttachment['src']
                  if(!this.isUpdate) {
                    delete mainAttachment['id']
                  }
                  dataMainAttachmentNew.push({...mainAttachment, path: document.filePath});
                }
              });
            });
            document.mainContractAttachments = [...dataMainAttachmentNew];
          } else {
            let mainContractAttachmentsNew = document.mainContractAttachments.filter(att => {
              if (!(att.source && att.source == 'FORM')) {
                const findInFileUpload = this.createContractMohaService.fileUploadArray.getValue().find((file: any) => !(file.source && file.source === 'FORM') && file.id === att.id);
                if(!att.src)
                return findInFileUpload;
              }
            });
            const dataMainAttachmentNew = [];
            mainContractAttachmentsNew = mainContractAttachmentsNew.concat(rs2.data);
            document.mainContractAttachments.forEach((mainAttachment, index) => {
              mainContractAttachmentsNew.forEach((mainAttachmentNew2) => {
                if(mainAttachment.fileName === mainAttachmentNew2.fileName ) {
                  dataMainAttachmentNew.push({
                    attachmentOrder: mainAttachment.attachmentOrder,
                    source: mainAttachment.source  || 'FILE',
                    ...mainAttachmentNew2
                  });
                }
                if (mainAttachment.source && mainAttachment.source == "FORM" && !dataMainAttachmentNew.map(item => item.source).includes('FORM')){
                  delete mainAttachment['src']
                  if(!this.isUpdate) {
                    delete mainAttachment['id']
                  }
                  dataMainAttachmentNew.push({...mainAttachment, path: document.filePath});
                }
              })
            });
            document.mainContractAttachments = [...dataMainAttachmentNew];
          }
          document.signPositions = document.signPositions.map(sign => {
            const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
            if (fileDoc && fileDoc.id) {
              sign.fileId = fileDoc.id;
            }
            return sign;
          });
        }
      }
      if ((rs.success && rs2 && rs2.success) || (rs.success && !rs2)) {
        document.enterpriseSign.forEach(ele => {
          if(ele.isSetupSignFlow){
            ele.customerApproves.forEach(ala =>{
              ala.positions = ala.positions.map(sign => {
                const fileDoc = document.mainContractAttachments.find(file => encodeURIComponent(file.fileName) === sign.fileId);
                if (fileDoc && fileDoc.id) {
                  sign.fileId = fileDoc.id;
                }
                return sign;
              });
            })
          }
        })
        this.saveDataWithAttachment(document, this.valueSelect);

      }
    })
  }

  isSaveDocumentFalse(){
    if(!this.isUpdate && this.createContractMohaService.createContractType.getValue() == 0){
      const formTemplate = this.createContractMohaService.fileFormTemplate.getValue()
      const mainContractAttachments = this.createContractMohaService.mainContractAttactment.getValue()
      if (mainContractAttachments && mainContractAttachments.length > 0 && formTemplate) {
        const newMainContractAttachments =  []
        mainContractAttachments.forEach(item => {
          if(item.source == 'FORM'){
            newMainContractAttachments.push({
              ...formTemplate,
              attachmentOrder: item.attachmentOrder
            })
          } else {
            newMainContractAttachments.push(item)
          }
        })
        const fileUploadArray = this.createContractMohaService.fileUploadArray.getValue()
        const fileUploadSrc = this.createContractMohaService.fileUploadSrc.getValue()
        this.createContractMohaService.fileUploadArray.next(fileUploadArray)
        this.createContractMohaService.fileUploadSrc.next(fileUploadSrc)
        this.createContractMohaService.mainContractAttactment.next(newMainContractAttachments)
      }
    } else if(this.isUpdate && this.createContractMohaService.createContractType.getValue() == 0){
      const mainContractAttachments = this.createContractMohaService.mainContractAttactment.getValue()
      if (mainContractAttachments && mainContractAttachments.length > 0 ) {
        const newMainContractAttachments =  []
        mainContractAttachments.forEach(item => {
          newMainContractAttachments.push(item)
        })
        const fileUploadArray = this.createContractMohaService.fileUploadArray.getValue()
        const fileUploadSrc = this.createContractMohaService.fileUploadSrc.getValue()
        this.createContractMohaService.fileUploadArray.next(fileUploadArray)
        this.createContractMohaService.fileUploadSrc.next(fileUploadSrc)
        this.createContractMohaService.mainContractAttactment.next(newMainContractAttachments)
      }
    }
  }

  saveContractWithNegotiate(id: any){
    if(this.isUpdate && this.createContractMohaService.document.getValue().negotiate){
      this.documentMohaService.continueContractWithNegotiate(id).subscribe(res => {
        if(res){
          this.toastr.success(this.message.getMessage('negotiate_contract.continue_negotiate_success'));
          this.router.navigate(['/home-enterprise/new-document-moha/'], {
            queryParams: {}
          });
        }
      })
    } else {
      this.documentMohaService.saveContractWithNegotiate(id).subscribe(res => {
        if(res){
          this.toastr.success(this.message.getMessage('negotiate_contract.change_negotiate_success'));
          this.router.navigate(['/home-enterprise/new-document-moha/'], {
            queryParams: {}
          });
        }
      })
    }

  }

  openPopupConfirm(){
    this.isNegotiate = true
    let document = this.createContractMohaService.document.getValue();
        let message = 'negotiate_contract.confirm_start_negotiate';
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '500px',
          data: this.commonService.format(this.message.getMessage(message), document.name)
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.onClickBtnSave(true)
          }
        });
  }

  async getInfoPl(id: string) {
    if (id) {
      this.originalContract = id;
      this.createContractMohaService.originalContract.next(this.originalContract);
      if (this.originalContract) {
        // this.createContractMohaService.isUpdateDocument = true;
      const res = await this.documentMohaService.getDocumentById(this.originalContract).toPromise();
      if (!res || !res.data || !res.data.contractDTO) {
        return;
      }
      console.log("detail-contract", res.data);

      let contract
      contract = {
        ...res.data.contractDTO
      };
      contract.contractAttachments = [];
      contract.contractCodePositions = [];
      contract.contractSharePartners = [];
      contract.contractShares = [];
      contract.documentTypeEnterpriseId = '';
      contract.fields = [];
      contract.filePath = '';
      contract.jsonData = '';
      contract.isConfirmBCT = false;
      contract.isDeleted = false;
      contract.isDifferentEnterprise = false;
      contract.isEditable = false;
      contract.isForwarded = false;
      contract.isSended = false;
      contract.negotiate = false;
      contract.mainContractAttachments = []
      contract.newUploadContractAttachments = [];
      contract.parents = [];
      contract.signPositions = [];
      contract.signatures = [];
      contract.templateFilePath = '';
      contract.typeId = null;
      contract.verifyPriceDetails = [];
      contract.contractMohaVersionNewFields = res.data.contractMohaVersionNewFields;
      contract.customerMohaId = res.data.customerMohaId;
      contract.code = '';
      contract.name = '';
      contract.expiredDate = null;
      contract.effectiveDate = null;
      contract.serviceType = null;
      contract.summary = '';
      contract.dataOriginalContract = [];
      const originalContract = {
        id: res.data.contractDTO.id,
        code: res.data.contractDTO.code,
        typeId: res.data.contractDTO.typeId,
        name: res.data.contractDTO.name,
      }
      contract.dataOriginalContract.push(originalContract);
      // this.createContractMohaService.selectedServiceType.next(res.data.serviceType);
      this.createContractMohaService.document.next(contract);
      this.createContractMohaService.contractMohaFields = contract.contractMohaVersionNewFields ? contract.contractMohaVersionNewFields : null;
      this.createContractMohaService.customerMohaId = contract.customerMohaId ? contract.customerMohaId : null;
      this.valueSelect = contract.typeId ? contract.typeId : 0;
      this.createContractMohaService.createContractType.next(this.valueSelect);
      delete contract.fileNameUpdate;
      delete contract.fileSizeUpdate;
      delete contract.documentTypeEnterpriseId;
      delete contract.signPositions;
      }
    }
  }

  async onClickBtnCreate(data: any){
    if (data && data.id) {
    const resCheck = await this.documentMohaService.checkContractOriginal(data.id).toPromise();
    if (!resCheck.success) {
      this.toastr.error(resCheck.message);
      return;
    }
    if (resCheck.data) {
      this.toastr.error(this.message.getMessage('messages.exists_pl'))
      return;
    }
     await this.getInfoPl(data.id);
    }
    let dataConfigHDLD = await this.getDataConfigHDLD();

    if(!dataConfigHDLD || !dataConfigHDLD.isSendMoha || !dataConfigHDLD.businessField || !dataConfigHDLD.businessType || !dataConfigHDLD.profession){
      setTimeout(() => {
        const dialogRef = this.dialog.open(AlertConfigDataHDLDComponent, {
          panelClass: 'alert-config-data-hdld',
          width: '450px',
          data: {
            message1: this.message.getMessage('add_document_moha.labor_contract_sync_not_configured_confirm'),
            message2: this.message.getMessage('add_document_moha.note_continue_create_contract_not_sync'),
            btn1: this.message.getMessage('add_document_moha.continue_create_contract'),
            btn2: this.message.getMessage('add_document_moha.go_to_configuration'),
          }
        });
        dialogRef.afterClosed().subscribe((res) => {
          if(res){
            let permistionList = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : []
            let userType = localStorage.getItem('userType') ? Number(localStorage.getItem('userType')) : 0
            if(userType == 1 || (userType == 2 && permistionList.includes(1))){
              this.router.navigate(['home-enterprise/labor-utilization-report']);
            }
            else{
              this.toastr.error(this.message.getMessage('messages.no_permission'))
            }
          }
          else{
            if(res == false){
              this.isShowListPage = false
            }
          }
        });
      });
    }
    else{
      this.isShowListPage = false
    }
  }
  // thêm mới phụ lục
  addDocumentPl(data: any) {
    if (data.id) {
      if (data.documentType === 1) {
        this.toastr.error(this.message.getMessage('messages.document_no_copy'));
      } else {
        this.documentMohaService.checkTemplate(data.id).subscribe(rs => {
          if (rs && rs.code === ErrorCode.DocumentInactive) {
            this.toastr.error(this.message.getMessage('messages.copy_contract_error_template_inactive'));
            return;
          }

          if (rs && rs.code === ErrorCode.CopyNotPermission) {
            this.toastr.error(rs.message);
            return;
          }

          this.documentMohaService.checkContractTerminationCopy(data.id).subscribe(res =>{
            if (res.success) {
              this.toNavigate('/home-enterprise/add-document-moha/' + data.id, {
                goFrom: 'hdld',
                typeCopy: data.typeId,

              });
            } else {
              this.toastr.error(res.message)
            }
          })
        });
      }
    }
  }

  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      routeLink: '/home-enterprise/search-my-created-document/',
    };
   this.router.navigate([route], {queryParams});
  }


  async getDataConfigHDLD(){
    let res = await this.documentMohaService.getDataConfigHDLD().toPromise()
    if(res){
      return res.data || null
    }
    else{
      return
    }
  }

  getDataStep3(){
    return {
      contractMohaFields: this.createContractMohaService.contractMohaFields,
      customerMohaId: this.createContractMohaService.customerMohaId,
      contractMohaUpdateFields: this.createContractMohaService.contractMohaUpdateFields,
      originalContract: this.createContractMohaService.originalContract.getValue(),
      adjustedContentSelected: this.createContractMohaService.adjustedContentSelected.getValue()
    }
  }

  checkTindy(callback?: () => void){
    this.contractService.checkTindyUser().subscribe(ref => {
      if(!ref.success){
        this.toastr.error(ref.message);
        return;
      }
      if(ref.data == 0 || ref.data == 2 ){
         //Popup anthention data
          let message = "";
         if(ref.data == 2){
         message = this.message.getMessage('notifyTindy.notify');
         }else if(ref.data == 0){
         message = this.message.getMessage('notifyTindy.notify_2')
         }
        const confirmDialog = this.dialog.open(WarningDataAuthenticationComponent, {
        width: '469px',
        height: '348px',
        data: {
          message
        }
         });
         confirmDialog.afterClosed().subscribe(ref => {
          if (ref) {
            this.dialog.open(SignAuthenticationPopupComponent, {
            panelClass: 'sign-authentication',
            width: '791px',
            height: 'auto',
            data: {
              message
            }
          });
          }
       });
      }else if(ref.data == 1){
        if(callback) callback();
      }
    })
  }

}
